import { getContentVariableTypeOptions } from "@/api/generated/@tanstack/react-query.gen";
import { Page, ResourceError } from "@/components/misc";
import { Breadcrumb, Skeleton, Tabs } from "@/components/ui";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Link, Outlet, useParams } from "@tanstack/react-router";

function VariableTypeEditLayout() {
  const { typeId } = useParams({ from: "/content/variables/$typeId" });

  const { data, isLoading, isError } = useQuery({
    ...getContentVariableTypeOptions({ path: { type_id: typeId } }),
  });

  if (isLoading) {
    return (
      <Page size="large" className="min-w-[48rem] space-y-6">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-48 w-full" />
        <Skeleton className="h-64 w-full" />
      </Page>
    );
  }

  if (isError || !data) {
    return (
      <Page size="large" className="min-w-[48rem]">
        <ResourceError
          title="Failed to load variable type"
          message="The variable type you're looking for doesn't exist or couldn't be loaded."
        />
      </Page>
    );
  }

  return (
    <Breadcrumb label={data.slug}>
      <Page size="large" className="min-w-[48rem] space-y-6">
        <Page.TitleContainer>
          <Page.Title>{data.slug}</Page.Title>
        </Page.TitleContainer>

        {
          /* Router-nav: each Trigger IS its route Link, which marks itself
            `data-status="active"` (+ aria-current) — so the active tab is
            self-determined. value={null} keeps Base UI from also selecting one. */
        }
        <Tabs variant="line" value={null}>
          <Tabs.List>
            <Tabs.Trigger
              value="values"
              render={
                <Link
                  to="/content/variables/$typeId/values"
                  params={{ typeId }}
                  activeOptions={{ includeSearch: false }}
                />
              }
            >
              Values
            </Tabs.Trigger>
            <Tabs.Trigger
              value="structure"
              render={
                <Link
                  to="/content/variables/$typeId/structure"
                  params={{ typeId }}
                  activeOptions={{ includeSearch: false }}
                />
              }
            >
              Structure
            </Tabs.Trigger>
          </Tabs.List>
        </Tabs>

        <Outlet />
      </Page>
    </Breadcrumb>
  );
}

export const Route = createFileRoute("/content/variables/$typeId")({
  component: VariableTypeEditLayout,
});
